export default "__VITE_ASSET__UPjelXm0__"